import { setIsSolicitudesPendLoading, setSolicitudesPend } from '../dashRedux'
import { getSolicitudPend } from '../restFunctios/getSolicitudPend'

export const getSolicitudPendAction = q => {
  return async dispatch => {
    dispatch(setIsSolicitudesPendLoading(true))
    const { data } = await getSolicitudPend(q)
    if (data) {
      dispatch(setSolicitudesPend(data.entities))
      dispatch(setIsSolicitudesPendLoading(false))
    } else {
      dispatch(setSolicitudesPend([]))
      dispatch(setIsSolicitudesPendLoading(false))
    }
  }
}
